window.jQuery = $;
window.$ = $;

require("@rails/ujs").start();

require("site/_site");
require("site/site.base");
require("site/site.product");
require("site/site.ready");